import { render, staticRenderFns } from "./story-detail.vue?vue&type=template&id=8079ff82&scoped=true&"
import script from "./story-detail.vue?vue&type=script&lang=js&"
export * from "./story-detail.vue?vue&type=script&lang=js&"
import style0 from "./story-detail.vue?vue&type=style&index=0&id=8079ff82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8079ff82",
  null
  
)

export default component.exports